import axios from "@/plugins/axios";

export default {
  getProgramPageList(searchQuery) {
    return axios.get("/program_pages/types/search", {
      params: { ...searchQuery },
    });
  },
  /** Metadata only — use for pickers / refresh (no HTML content). */
  getProgramPageMetaList() {
    return axios.get("/program_pages/meta");
  },
  getProgramPageCount(searchQuery) {
    return axios.get("/program_pages/types/count", {
      params: { ...searchQuery },
    });
  },
  getProgramPagesByIds(ids) {
    const list = Array.isArray(ids) ? ids.filter(Boolean) : [];
    return axios.get("/program_pages/by-ids", {
      params: { ids: list.join(",") },
    });
  },
  getOneProgramPage(page_id) {
    return axios.get(`/program_pages/${page_id}`);
  },
  addProgramPage(data) {
    return axios.post("/program_pages", data);
  },
  updateProgramPage(page_id, data, cache) {
    return axios.post(`/program_pages/${page_id}`, { data, cache });
  },
  deleteProgramPage(page_id) {
    return axios.delete(`/program_pages/${page_id}`);
  },
};
